// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1q_iU","label":"LabeledBox_label__15HxV"};